import { NMCrypto } from "@neumetric/blueprint-lib/utility";
import { Col } from "@neumetric/blueprint-lib/components";
import { useSelector } from "react-redux";
import { getCurrentUser, getModuleById } from "@neumetric/blueprint-lib/store";

export const AuditStatsPage = () => {
  const currentUser = useSelector(getCurrentUser);
  const centralmod = useSelector(getModuleById.bind(null, "central"));
  const redirect = NMCrypto.encrypt({ search: "?module=auditor&standalone=true", path: "/C/O" });
  const path = `${centralmod.link}login?sessionToken=${currentUser.sessionToken}&redirect=${redirect}`;

  return (
    <Col className="w-100 h-100 overflow-hide audit-state">
      <iframe src={path} className="w-100 h-100 stats-iframe" />
    </Col>
  );
};
